import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Platforms from './pages/Platforms';
import ProAccount from './pages/ProAccount';
import PrimeAccount from './pages/PrimeAccount';
import PremiumAccount from './pages/PremiumAccount';
import Forex from './pages/Forex';
import Commodities from './pages/Commodities';
import Indices from './pages/Indices';
import Shares from './pages/Shares';
import Partnership from './pages/Partnership';
import CompanyValues from './pages/CompanyValues';
import WhyRiverPrime from './pages/WhyRiverPrime';
import Regulations from './pages/Regulations';
import Support from './pages/Support';
import Admin from './pages/Admin';
import './styles/App.css';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/admin" element={<Admin />} />
            <Route path="/*" element={
              <>
                <Header />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/platforms" element={<Platforms />} />
                    <Route path="/accounts/pro" element={<ProAccount />} />
                    <Route path="/accounts/prime" element={<PrimeAccount />} />
                    <Route path="/accounts/premium" element={<PremiumAccount />} />
                    <Route path="/markets/forex" element={<Forex />} />
                    <Route path="/markets/commodities" element={<Commodities />} />
                    <Route path="/markets/indices" element={<Indices />} />
                    <Route path="/markets/shares" element={<Shares />} />
                    <Route path="/partnership" element={<Partnership />} />
                    <Route path="/about/company-values" element={<CompanyValues />} />
                    <Route path="/about/why-river-prime" element={<WhyRiverPrime />} />
                    <Route path="/about/regulations" element={<Regulations />} />
                    <Route path="/support" element={<Support />} />
                  </Routes>
                </main>
                <Footer />
              </>
            } />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;